import React, { useEffect, useState } from 'react';
import GridInputs from '../../components/common/inputs/GridInputs';
import MenuItem from '@mui/material/MenuItem';
import { IData } from './Interface';
import axios from 'axios';
import { SubmitButton } from '../../components/common/button/CustomButtons';
import SelectGridMui from '../../components/common/selectscustom/SelectGridMui';
import useConfirm from '../../components/common/useConfirm';
import GridSelect from '../../components/common/inputs/GridSelect';
import { SelectChangeEvent } from '@mui/material';

const Create = ({
  id,
  setIsModal,
}: {
  id?: string | null;
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [machine, setMachine] = useState<IData>({});
  const [DialogSubmit, confirmSubmit] = useConfirm(
    `${id ? 'Update Tools' : 'Create Tools'}`,
    `Are you sure you want to ${id ? 'update' : 'save'} this?`
  );

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/masterListOfTools/${id}`)
        .then((res) => {
          setMachine(res.data);
        })
        .catch((err) => console.log(err));
    }
  }, [id]);

  function handleSupplier(
    e: React.ChangeEvent<HTMLInputElement> | SelectChangeEvent<unknown>
  ) {
    setMachine((prev: any) => ({ ...prev, [e.target.name]: e.target.value }));
  }

  const handleSumbit = async () => {
    const ans = await confirmSubmit();
    if (!ans) return;
    if (id) {
      await axios
        .put(`/api/masterListOfTools/${id}`, machine)
        .then((res) => {
          setIsModal(false);
        })
        .catch((err) => console.log(err));
    } else {
      machine.is_admin_request = 'pending';
      await axios
        .post('/api/masterListOfTools', machine)
        .then((res) => {
          setIsModal(false);
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <>
      <GridInputs
        id={'tool_details'}
        name={'tool_details'}
        html_for={'tool_details'}
        label_name={'TOOL NAME'}
        input_type={'text'}
        focusType={'onblur'}
        value={machine?.tool_details}
        onChange={handleSupplier}
      />
      <GridInputs
        id={'tool_no'}
        name={'tool_no'}
        html_for={'tool_no'}
        label_name={'TOOL NO.'}
        input_type={'text'}
        focusType={'onblur'}
        value={machine?.tool_no}
        onChange={handleSupplier}
      />
      <GridInputs
        id={'part_name'}
        name={'part_name'}
        html_for={'part_name'}
        label_name={'PART NAME'}
        input_type={'text'}
        focusType={'onblur'}
        value={machine?.part_name}
        onChange={handleSupplier}
      />
      <GridInputs
        id={'remarks'}
        name={'remarks'}
        html_for={'remarks'}
        label_name={'REMARKS'}
        input_type={'text'}
        focusType={'onblur'}
        value={machine?.remarks}
        onChange={handleSupplier}
      />

      <div
        className="btn_save"
        style={{
          position: 'absolute',
          right: '140px',
          top: '-0.6px',
        }}
      >
        <SubmitButton
          label={`${id ? 'update' : 'submit'}`}
          type="button"
          onClick={handleSumbit}
        />
      </div>
      <DialogSubmit />
    </>
  );
};

export default Create;
